import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import config from '../../../config';
import { HeaderLogo } from '../HeaderNav';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLang, withLang } from '../../../i18n/langPath';
import { SUPPORTED_LANGUAGES } from '../../../i18n';

const LANGUAGE_LABELS = {
  en: 'English',
  nl: 'Nederlands',
  es: 'Español',
};
const LANGUAGE_OPTIONS = ['en', 'nl', 'es'].filter((code) =>
  SUPPORTED_LANGUAGES.includes(code),
);

const Area = styled.div`
  height: 500px;
  position: relative;
  z-index: 2;
  background-color: #000;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 58px;
  padding-left: 20px;
  padding-right: 20px;

  .ot-sdk-show-settings {
    padding: 0;
  }

  @media ${config.layout.wide} {
    height: 670px;
    padding-top: 100px;
    padding-left: 50px;
    padding-right: 50px;
  }

  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 4px;
    z-index: 1;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1400" height="8" viewBox="0 0 1400 8"><defs><pattern id="pattern" preserveAspectRatio="none" width="100%" height="100%" viewBox="0 0 3079 55"><image width="3079" height="55" xlink:href="data:image/png;base64,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"/></pattern></defs><rect id="gradient_2x" data-name="gradient@2x" width="1400" height="8" fill="url(%23pattern)"/></svg>');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
`;

const ATCLink = styled.a`
  color: #ffffff;
  text-decoration: none;
  font-size: 14px;
  //font-weight: bold;
  margin-top: 35px;
  margin-bottom: 30px;

  @media ${config.layout.wide} {
    margin-top: 70px;
    margin-bottom: 100px;
  }
`;

const BrandLinks = styled.div`
  margin-top: 50px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;

  @media ${config.layout.wide} {
    margin-top: 100px;
    gap: 32px;
  }

  a {
    svg {
    }
  }
`;

const Links = styled.div`
  display: flex;
  align-items: center;
  //justify-content: space-around;
  margin-top: 35px;
  gap: 8px;
  flex-wrap: wrap;
  text-align: center;
  justify-content: center;

  @media ${config.layout.wide} {
    //justify-content: space-between;
    margin-top: 95px;
  }

  .spacer {
    flex: 0 0 auto;
  }

  a,
  button {
    @media ${config.layout.wide} {
    }
    outline: none;
    border: none;
    flex: 0 0 auto;
    color: #ffffff;
    text-decoration: none;
    font-size: 14px;
    
  }
`;

const FooterLogoLinkElm = styled.a`
  display: block;
  position: relative;
  left: 8px;

  svg {
    width: 146px;
    @media ${config.layout.wide} {
      width: 220px;
      left: 18px;
    }

    .hlst0 {
      fill: #f5501e;
    }
  }

  @media ${config.layout.mobile} {
  }

  @media ${config.layout.wide} {
  }
`;

const Tagline = styled.div`

  font-size: 16px;
  margin-top: 5px;
  @media ${config.layout.wide} {
    font-size: 20px;
    margin-top: 7px;
  }
`;

const LanguageSwitcherArea = styled.div`
  position: absolute;
  right: 0px;
  bottom: 0px;
  z-index: 5;
  overflow: hidden;
  padding-bottom: 20px;
  padding-top: 45px;

  @media ${config.layout.mobile} {
    left: 0px;
  }

  @media ${config.layout.wide} {
    right: 0px;
  }

  &.open {
    background-color: #f0f0f0;
  }
`;

const LanguageOptionList = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;

const LanguageOption = styled.button`
  display: block;
  width: 100%;
  text-align: left;
  padding: 14px 67px;
  background: transparent;
  border: none;
  color: #000;
  font-size: 16px;
  cursor: pointer;

  @media ${config.layout.mobile} {
    text-align: center;
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

  &.active {
    color: #898989;
  }
    
`;

const LanguageTriggerElm = styled.button`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  width: 100%;
  background: transparent;
  border: none;
  color: #fff;
  font-size: 14px;
  padding: 14px 20px;
  cursor: pointer;
  position: relative;
  right: 20px;

  svg {
    flex: 0 0 auto;
    transition: transform 0.15s linear;
  }

  &.open {
    color: #000;
  }

  &.open svg {
    transform: rotateZ(180deg);
  }
`;

function ChevronDownIcon() {
  return (
      <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
        <path d="M1 1l5 5 5-5" stroke="currentColor" strokeWidth="2"
              fill="none" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
  );
}

function LanguageSwitcher() {
  const lang = useLang();
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) {
      return;
    }
    const onClickOutside = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => {
      document.removeEventListener('mousedown', onClickOutside);
    };
  }, [open]);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const onSelect = (code) => {
    setOpen(false);
    if (code === lang) {
      return;
    }
    const rest = location.pathname.replace(new RegExp(`^/${lang}`), '') || '/';
    navigate(`/${code}${rest}${location.search}${location.hash}`);
  };

  return (
      <LanguageSwitcherArea ref={wrapRef} className={open ? 'open' : ''}>
        {open && (
            <LanguageOptionList>
              {LANGUAGE_OPTIONS.map((code) => (
                  <LanguageOption
                      key={code}
                      className={code === lang ? 'active' : ''}
                      onClick={() => onSelect(code)}
                  >
                    {LANGUAGE_LABELS[code]}
                  </LanguageOption>
              ))}
            </LanguageOptionList>
        )}
        <LanguageTriggerElm
            type="button"
            className={open ? 'open' : ''}
            onClick={() => setOpen((v) => !v)}
        >
          <span>{LANGUAGE_LABELS[lang]}</span>
          <ChevronDownIcon/>
        </LanguageTriggerElm>
      </LanguageSwitcherArea>
  );
}

function FooterLogoLink() {
  const location = useLocation();
  const navigate = useNavigate();
  const lang = useLang();
  const topPath = withLang(lang, '/');
  //console.log(location);

  if (location.pathname.replace(/\/$/, '') == topPath.replace(/\/$/, '')) {
    // 同じページ内に既にいる
    return (
      <FooterLogoLinkElm
        href={'#'}
        onClick={(e) => {
          e.preventDefault();
          if (location.hash) {
            navigate(topPath);
          } else {
            window.scrollTo(0, 0);
          }
        }}
      >
        <HeaderLogo />
      </FooterLogoLinkElm>
    );
  }

  return (
    <FooterLogoLinkElm href={topPath}>
      <HeaderLogo />
    </FooterLogoLinkElm>
  );
}

export default function Footer() {
  const { t } = useTranslation();
  return (
    <Area>
      <FooterLogoLink />
      <Tagline>{t('footer.tagline')}</Tagline>
      <Links>
        <a
          href="https://alphatheta.com/company/privacy-policy/"
          target="_blank"
          rel="noopener"
        >
          {t('footer.privacyPolicy')}
        </a>
        <div className="spacer">|</div>
        <a
          href="https://alphatheta.com/company/terms-of-use/"
          target="_blank"
          rel="noopener"
        >
          {t('footer.termsOfUse')}
        </a>
        <div className="spacer">|</div>
        <a
          href="https://alphatheta.com/company/trademarks/"
          target="_blank"
          rel="noopener"
        >
          {t('footer.trademarks')}{' '}
        </a>
        <div className="spacer">|</div>
        <a
          href="https://alphatheta.com/company/cookie-policy/"
          target="_blank"
          rel="noopener"
        >
          {t('footer.cookiePolicy')}
        </a>
        <div className="spacer">|</div>
        <button className="ot-sdk-show-settings">
          {t('footer.cookieSettings')}
        </button>
      </Links>

      <BrandLinks>
        <a target={'_blank'} href="https://www.pioneerdj.com/">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={119}
            height={17}
            fill="none"
          >
            <path
              fill="#fff"
              d="M14.983 4.74c-.33.932-2.413 1.904-7.525.748l.662 3.02c5.117.926 8.146.167 9.877-1.65 1.283-1.344 1.533-3.09.479-4.424C17.36 1.024 14.892 0 11.776 0c-4.46 0-7.637 1.293-9.404 6.14L0 12.656h4.15l2.356-6.592c.973-2.709 3.004-3.162 5.265-3.162 2.367 0 3.513.972 3.207 1.833l.005.005ZM56.073 7.6l-.157-.071a7.939 7.939 0 0 1 2.937-.57c.606 0 1.96.106 2.53.427.138.082.265.204.2.357-.255.565-3.956.534-5.504-.143m7.575-1.527c-.982-.525-2.596-.942-4.18-1.008-3.278-.133-7.02.982-7.763 3.63-.433 1.522 1.043 3.579 4.882 4.16 1.92.29 4.974.218 7.173-.505l.82-2.26c-4.455 1.532-10.279 1.084-10.08-1.207 2.158 1.38 5.3 1.252 7.626.87 4.032-.661 3.976-2.372 1.527-3.68h-.005ZM70.456 7.6l-.158-.071a7.958 7.958 0 0 1 2.938-.57c.61 0 1.96.106 2.53.427.138.082.265.204.199.357-.25.565-3.951.534-5.504-.143m7.576-1.527c-.983-.525-2.597-.942-4.18-1.008-3.279-.133-7.02.982-7.764 3.63-.428 1.522 1.044 3.579 4.882 4.16 1.925.29 4.974.218 7.169-.505l.82-2.26c-4.455 1.532-10.28 1.084-10.081-1.207 2.154 1.38 5.3 1.252 7.627.87 4.037-.661 3.976-2.372 1.527-3.68Zm3.029 1.945-1.644 4.643h3.798l1.267-3.57c.31-.905.576-1.583 1.685-1.583h2.668l.749-2.138H84.67c-1.645 0-2.969.82-3.605 2.653v-.005Zm-63.644 4.637h3.935l2.658-7.295h-3.936l-2.657 7.295Zm25.522-3.92c.366-1.003 1.471-1.466 2.438-1.466.968 0 1.879.565 1.523 1.543l-1.406 3.849h3.798l1.426-3.91c.738-2.032-.86-3.717-4.45-3.717-3.991 0-6.257 1.309-7.127 3.696l-1.43 3.925h3.797l1.43-3.925v.005Zm-11.72-1.4c1.537.066 2.774.84 2.55 1.843-.213.968-1.71 1.624-3.258 1.558-1.537-.066-2.774-.84-2.55-1.843.213-.967 1.705-1.624 3.258-1.558Zm.54-2.265c-3.956-.168-7.484 1.522-7.958 3.686-.468 2.128 2.205 4.078 6.176 4.246 3.956.168 7.484-1.523 7.957-3.686.468-2.128-2.204-4.078-6.175-4.246ZM110.219 2.398C108.666 1.2 106.456 1.1 103.835 1.1h-5.193l-4.2 11.556h5.905c2.566 0 4.913-.336 7.168-1.598 2.037-1.16 3.325-2.663 3.89-4.21.606-1.67.341-3.269-1.191-4.45h.005Zm-3.152 4.363c-.31.86-.901 1.91-1.914 2.617-2.388 1.665-5.259 1.492-5.259 1.492s-.804-.046-.474-.942c2.47-6.802 2.251-6.17 2.409-6.532.249-.576.885-.504.885-.504l.734-.016c1.507 0 2.55.092 3.238.902.611.722.712 2.082.381 2.993v-.01ZM119.003 5.356h-5.886l-.58 1.598h1.115c.738 0 .423.912.423.912l-1.833 5.03c-.143.387-.922 2.418-5.468 2.199l-.657 1.802h3.065c4.027 0 6.023-1.069 6.96-3.665l2.856-7.881.005.005Z"
            />
          </svg>
        </a>
        <a target={'_blank'} href="https://alphatheta.com/">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={107}
            height={17}
            fill="none"
          >
            <path
              fill="#fff"
              d="m29.349 2.38 4.443 11.537h-2.165l-1.083-3.054H25.94l-1.083 3.053h-2.084L27.2 2.381h2.149Zm-1.115 1.988-1.745 4.96h3.522l-1.728-4.96h-.049ZM36.85 2.38v11.537h-1.842V2.38h1.842ZM47.007 9.778c0 2.197-1.1 4.362-3.603 4.362-1.05 0-2.23-.371-2.795-1.308h-.033V17h-1.842V5.561h1.745v1.131h.033c.533-.97 1.518-1.357 2.585-1.357 2.617 0 3.91 2.003 3.91 4.443Zm-4.153 2.908c1.664 0 2.31-1.486 2.31-2.94 0-1.39-.694-2.957-2.326-2.957-1.712 0-2.327 1.454-2.327 2.957 0 1.438.711 2.94 2.343 2.94ZM50.076 2.38v4.282h.033c.533-.84 1.47-1.325 2.52-1.325 1.922 0 2.94 1.115 2.94 2.78v5.8h-1.841v-5.17c0-1.067-.324-1.956-1.632-1.956-1.277 0-2.02 1.05-2.02 2.15v4.975h-1.842V2.381h1.842ZM64.343 7.71v4.395c0 .436.097.581.5.581.097 0 .259 0 .388-.032v1.276c-.469.13-.953.21-1.163.21-.808 0-1.292-.323-1.422-1.018-.662.663-1.874 1.018-2.892 1.018-1.648 0-2.86-.905-2.86-2.44 0-1.566.921-2.18 2.166-2.44.63-.128 1.324-.209 2.1-.306 1.115-.13 1.454-.388 1.454-1.034 0-.727-.582-1.131-1.729-1.131-1.13 0-1.76.485-1.842 1.325h-1.841c.129-1.826 1.454-2.779 3.796-2.779 2.02 0 3.345.953 3.345 2.375Zm-4.023 4.976c1.26 0 2.18-.63 2.18-1.535V9.73c-.5.308-.742.308-2.019.47-1.212.145-1.745.58-1.745 1.34 0 .695.582 1.147 1.584 1.147ZM74.022 2.38v1.746h-3.667v9.79h-2.02v-9.79h-3.651V2.38h9.338ZM76.783 2.38v4.282h.033c.533-.84 1.47-1.325 2.52-1.325 1.922 0 2.94 1.115 2.94 2.78v5.8h-1.841v-5.17c0-1.067-.323-1.956-1.632-1.956-1.277 0-2.02 1.05-2.02 2.15v4.975h-1.842V2.381h1.842ZM91.506 9.584c0 .21-.016.42-.033.63h-6.139c0 1.374.791 2.472 2.246 2.472 1.017 0 1.696-.42 2.035-1.39h1.745c-.371 1.794-1.955 2.844-3.78 2.844-2.634 0-4.088-1.842-4.088-4.378 0-2.407 1.551-4.427 4.04-4.427 2.358 0 3.974 1.939 3.974 4.25Zm-1.874-.581c-.097-1.164-.857-2.214-2.117-2.214-1.292 0-2.116.986-2.181 2.214h4.297ZM95.27 3.06v2.505h1.664v1.373H95.27v4.556c0 .873.21 1.05.921 1.05.34 0 .679-.032.743-.064v1.422c-.727.08-.937.097-1.195.097-1.761 0-2.31-.566-2.31-2.246V6.938h-1.39V5.565h1.39V3.061h1.841ZM105.499 7.71v4.395c0 .436.097.581.501.581.097 0 .258 0 .388-.032v1.276c-.469.13-.954.21-1.164.21-.808 0-1.292-.323-1.421-1.018-.663.663-1.875 1.018-2.893 1.018-1.647 0-2.86-.905-2.86-2.44 0-1.566.922-2.18 2.166-2.44.63-.128 1.324-.209 2.1-.306 1.115-.13 1.454-.388 1.454-1.034 0-.727-.582-1.131-1.729-1.131-1.131 0-1.761.485-1.841 1.325h-1.842c.13-1.826 1.454-2.779 3.797-2.779 2.019 0 3.344.953 3.344 2.375Zm-4.023 4.976c1.26 0 2.181-.63 2.181-1.535V9.73c-.501.308-.743.308-2.02.47-1.211.145-1.744.58-1.744 1.34 0 .695.581 1.147 1.583 1.147ZM16.784 1.23C13.875-1.15 9.654.202 7.141 2.903c-.34.365-.648.763-.932 1.18 1.46-1.93 3.646-3.146 5.77-2.987 3.124.235 4.933 3.353 4.041 6.964-.892 3.612-4.148 6.35-7.271 6.115-2.797-.21-4.538-2.732-4.232-5.85.935-.517 1.98-.711 2.92-.459 1.834.492 2.599 2.497 1.778 4.546a5.651 5.651 0 0 0 .504-1.782 4.483 4.483 0 0 0 .008-.798C9.56 7.8 7.938 6.033 5.243 6.486.873 7.222-1.43 12.07.964 14.921c1.46 1.739 4.07 1.486 5.93.242 1.438 1.021 3.406 1.369 5.695.523 6.618-2.444 8.784-10.706 4.195-14.457ZM3.915 15.563c-1.9-.51-2.653-2.646-1.68-4.771a5.436 5.436 0 0 1 2.228-2.436 8.617 8.617 0 0 0-.1 2.172 7.106 7.106 0 0 0 .223 1.25c.37 1.345 1.148 2.532 2.236 3.331-.93.512-1.97.705-2.907.454Z"
            />
          </svg>
        </a>
        <a target={'_blank'} href="https://rekordbox.com/">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={121}
            height={17}
            fill="none"
          >
            <path
              fill="#fff"
              d="M12.08 7.101c.165.498.256 1.03.256 1.582 0 2.397-1.668 4.394-3.875 4.842V17l5.943-3.513c.38-.224.615-.64.615-1.094V5.36l-2.94 1.74ZM3.896 5.421a4.765 4.765 0 0 1 3.612-1.674c1.438 0 2.731.651 3.613 1.674l2.94-1.74L8.123.168a1.216 1.216 0 0 0-1.235 0L.945 3.681l2.94 1.74h.01ZM2.683 8.683c0-.553.09-1.084.257-1.582L0 5.361v7.026c0 .45.235.87.615 1.095l5.943 3.513V13.52c-2.213-.449-3.875-2.446-3.875-4.843v.006ZM9.925 8.682c0 1.368-1.08 2.474-2.416 2.474-1.336 0-2.415-1.106-2.415-2.474S6.174 6.21 7.509 6.21c1.337 0 2.416 1.105 2.416 2.473ZM79.12.185v3.36h-3.864c-.834 0-1.652.07-2.475.207-1.315.22-2.127 1.472-2.24 2.72a23.508 23.508 0 0 0 0 4.421c.113 1.248.925 2.495 2.24 2.72.823.137 1.64.208 2.475.208 2.132 0 4.265.005 6.397.01V.186H79.12Zm0 11.573h-3.11c-2.695 0-3.042-.35-3.042-3.08 0-2.731.347-3.082 3.041-3.082h3.11v6.162ZM94.877 6.466c-.112-1.247-.925-2.495-2.24-2.72a15.008 15.008 0 0 0-2.474-.207H86.3V.185h-2.533V13.82c2.132 0 4.265-.006 6.397-.011.834 0 1.651-.066 2.475-.208 1.314-.22 2.127-1.472 2.239-2.72a23.508 23.508 0 0 0 0-4.421v.005Zm-5.468 5.292H86.3V5.596h3.11c2.694 0 3.041.35 3.041 3.081 0 2.73-.347 3.08-3.04 3.08ZM60.938 6.417a3.073 3.073 0 0 0-2.608-2.72 19.93 19.93 0 0 0-5.762 0 3.068 3.068 0 0 0-2.608 2.72 21.455 21.455 0 0 0 0 4.536 3.073 3.073 0 0 0 2.608 2.72c1.94.279 3.822.279 5.762 0a3.068 3.068 0 0 0 2.608-2.72c.16-1.482.16-3.053 0-4.536Zm-2.501 3.924c-.054.569-.262.913-.754 1.198-.374.224-.759.219-1.165.24-.893.055-1.775.039-2.667-.038-.604-.054-.946-.284-1.224-.826-.187-.361-.182-.728-.203-1.105a19.538 19.538 0 0 1 .037-2.796c.054-.57.262-.914.754-1.199.374-.219.759-.219 1.165-.24a18.083 18.083 0 0 1 2.667.038c.604.054.946.284 1.224.826.187.361.182.728.203 1.105.053.898.037 1.905-.037 2.797ZM107.571 6.417a3.074 3.074 0 0 0-2.608-2.72 19.932 19.932 0 0 0-5.762 0 3.068 3.068 0 0 0-2.608 2.72 21.455 21.455 0 0 0 0 4.536 3.074 3.074 0 0 0 2.608 2.72c1.94.279 3.821.279 5.762 0a3.069 3.069 0 0 0 2.608-2.72c.16-1.482.16-3.053 0-4.536Zm-2.502 3.924c-.053.569-.261.913-.753 1.198-.374.224-.759.219-1.165.24-.893.055-1.775.039-2.667-.038-.604-.054-.946-.284-1.224-.826-.187-.361-.182-.728-.203-1.105a19.523 19.523 0 0 1 .037-2.796c.054-.57.262-.914.754-1.199.374-.219.759-.219 1.165-.24a18.086 18.086 0 0 1 2.667.038c.604.054.946.284 1.224.826.187.361.181.728.203 1.105.053.898.037 1.905-.038 2.797ZM66.744 5.673c-.193.033-.38.082-.567.191-.118.072-.23.148-.331.241a1.257 1.257 0 0 0-.305.443c-.09.22-.112.455-.128.69-.043.503-.032 1.007-.032 1.516v5.061h-2.576V8.677c0-.739.037-1.472.117-2.21 0-.345.155-.74.305-1.04.155-.318.369-.608.62-.854.262-.252.566-.454.892-.602.407-.175.845-.24 1.278-.3.358-.05.71-.072 1.069-.083.71-.027 2.448-.066 2.448-.066v2.063s-2-.043-2.79.088ZM23.416 5.673c-.193.033-.38.082-.567.191-.118.072-.23.148-.331.241a1.257 1.257 0 0 0-.305.443c-.09.22-.112.455-.128.69-.043.503-.032 1.007-.032 1.516v5.061h-2.576V8.677c0-.739.037-1.472.117-2.21 0-.345.155-.74.305-1.04.155-.318.369-.608.62-.854.262-.252.566-.454.892-.602.406-.175.845-.24 1.278-.3.352-.05.71-.072 1.069-.083.71-.027 2.447-.066 2.447-.066v2.063s-1.998-.043-2.79.088ZM44.493 8.683l5.098-5.138h-2.8l-3.736 4.11h-.267v-4.11h-2.55V13.82h2.55V9.706h.262l3.74 4.115h2.801l-5.104-5.138h.006ZM120.02 3.545h-2.801l-3.206 3.579-3.212-3.58H108l4.607 5.14L108 13.82h2.801l3.212-3.578 3.206 3.578h2.801l-4.607-5.138 4.607-5.138ZM38.214 10.795H35.67c-.021.076-.064.219-.064.219-.155.443-.39.63-.85.684a18.196 18.196 0 0 1-4.083 0 1.023 1.023 0 0 1-.898-.903 21.289 21.289 0 0 1-.112-1.653h8.658v-.306c.01-.815-.032-1.62-.117-2.43a3.073 3.073 0 0 0-2.609-2.72c-1.94-.278-3.821-.278-5.761 0a3.068 3.068 0 0 0-2.608 2.72 21.455 21.455 0 0 0 0 4.537 3.073 3.073 0 0 0 2.608 2.72c1.94.278 3.821.278 5.761 0 .129-.017.252-.045.374-.077.123-.033.24-.077.358-.12a3.054 3.054 0 0 0 .93-.607c.091-.089.177-.176.252-.275.08-.098.155-.197.219-.3.07-.105.128-.214.181-.329a2.919 2.919 0 0 0 .29-1.045c0-.033.01-.066.01-.104l.005-.011ZM29.78 6.549c.054-.476.428-.848.898-.903a18.195 18.195 0 0 1 4.084 0c.47.055.844.427.897.903.038.35.07.695.091 1.045h-6.055c.016-.35.048-.7.09-1.045h-.005Z"
            />
          </svg>
        </a>
        <a
          target={'_blank'}
          href="https://www.pioneerdj.com/landing/toraiz-brand/"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={82}
            height={17}
            fill="none"
          >
            <path
              fill="#fff"
              d="M64.616.31h4.199v16.38h-4.2V.31ZM19.904 0c5.066 0 8.689 3.94 8.689 8.501 0 4.562-3.6 8.501-8.712 8.501-5.111 0-8.644-4.095-8.644-8.301 0-1.084.156-2.303.645-3.497C12.75 3.076 15.304 0 19.904 0Zm.067 13.327c2.978 0 4.423-2.7 4.423-4.803 0-2.103-1.445-4.849-4.466-4.849-3.022 0-4.49 2.48-4.49 4.783 0 2.523 1.71 4.869 4.533 4.869ZM55.071.31h-2.733l-8.129 14.023 1.367 2.358h16.255l1.366-2.358L55.071.311Zm-5.517 12.705 4.167-7.188 4.166 7.188h-8.333ZM43.542 5.956c0-1.683-.666-3.41-2.02-4.472C40.453.664 39.342.31 36.455.31h-6.161v16.38h4.2V3.986h2.316c1.622 0 2.71.73 2.71 2.213 0 .797-.288 2.344-2.75 2.346h-.592v2.565l2.842 5.58h4.521l-3.334-5.757c2.516-.799 3.334-3.258 3.334-4.977ZM70.64 13.947l5.666-9.961H70.64V.311h10.378v3.386l-5.245 9.318h5.245v3.676H70.639v-2.746.002ZM3.263 3.986H.018V.311h10.666v3.675H7.462v12.705H3.263V3.986Z"
            />
          </svg>
        </a>
        <a target={'_blank'} href="https://www.pioneerproaudio.com/">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={98}
            height={15}
            fill="none"
          >
            <path
              fill="#fff"
              d="M16.46 5.197c-.356.998-2.586 2.042-8.066.805l.711 3.235c5.481.996 8.73.177 10.584-1.77 1.375-1.443 1.644-3.311.514-4.742-1.192-1.51-3.837-2.608-7.178-2.608-4.78 0-8.184 1.385-10.073 6.579L.408 13.682h4.449l2.528-7.064c1.04-2.906 3.22-3.387 5.64-3.387 2.42 0 3.764 1.045 3.436 1.966h-.002ZM60.496 8.263l-.17-.074a8.53 8.53 0 0 1 3.147-.613c.652 0 2.1.111 2.71.458.15.085.284.215.211.38-.27.606-4.235.572-5.898-.153v.002Zm8.125-1.636c-1.052-.562-2.786-1.009-4.48-1.078-3.514-.144-7.524 1.055-8.324 3.888-.46 1.63 1.12 3.833 5.235 4.458 2.059.313 5.328.235 7.684-.543l.879-2.42C64.84 12.572 58.6 12.097 58.81 9.64c2.31 1.48 5.68 1.34 8.175.933 4.323-.708 4.26-2.545 1.636-3.947v.001ZM75.906 8.263l-.17-.074a8.537 8.537 0 0 1 3.147-.613c.652 0 2.1.111 2.71.458.148.085.284.215.211.38-.27.606-4.235.572-5.9-.153l.002.002Zm8.125-1.636c-1.052-.562-2.786-1.009-4.48-1.078-3.514-.144-7.522 1.055-8.323 3.888-.461 1.63 1.12 3.833 5.234 4.458 2.059.313 5.329.235 7.684-.543l.879-2.42C80.25 12.572 74.01 12.097 74.22 9.64c2.31 1.48 5.68 1.34 8.174.933 4.323-.708 4.26-2.545 1.636-3.947v.001ZM87.274 8.709l-1.764 4.973h4.07l1.357-3.825c.334-.97.616-1.697 1.803-1.697h2.86l.805-2.293h-5.272c-1.762 0-3.181.876-3.86 2.842h.001ZM19.072 13.682h4.217l2.85-7.815h-4.217l-2.85 7.815ZM46.429 9.477c.391-1.075 1.573-1.573 2.613-1.573s2.013.605 1.63 1.653l-1.505 4.125h4.07l1.528-4.191c.793-2.176-.924-3.98-4.768-3.98-4.28 0-6.706 1.401-7.64 3.961l-1.535 4.21h4.071l1.534-4.205h.002ZM33.866 7.982c1.646.07 2.972.9 2.736 1.975-.227 1.036-1.83 1.74-3.493 1.671-1.646-.07-2.972-.899-2.735-1.974.227-1.037 1.83-1.74 3.494-1.671h-.002Zm.574-2.428c-4.24-.18-8.018 1.633-8.526 3.953-.5 2.279 2.364 4.372 6.62 4.551 4.24.18 8.019-1.632 8.527-3.952.5-2.28-2.364-4.372-6.621-4.552Z"
            />
          </svg>
        </a>
      </BrandLinks>

      <ATCLink
        href="https://alphatheta.com/"
        target="_blank"
        rel="noopener"
        className={'alphatheta'}
      >
        {t('footer.copyright')}
      </ATCLink>

      <LanguageSwitcher/>
    </Area>
  );
}
